import { render, staticRenderFns } from "./ItemD_PackagingList.vue?vue&type=template&id=5c28c7d2"
import script from "./ItemD_PackagingList.vue?vue&type=script&lang=js"
export * from "./ItemD_PackagingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports